import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../assets/images/arbitrator_logo.png';
import { Link } from 'react-router-dom';
import { FaFacebookSquare, FaLinkedin, FaTelegramPlane } from 'react-icons/fa';
import Logo_En from '../../assets/images/arbitrator_white_logo.png'
import Arbitrator_new_logo_eng from '../../assets/images/new-logo-white.svg';
import Arbitrator_new_logo_ru from '../../assets/images/new-logo-ru-white.svg';
import Arbitrator_new_logo_uz from '../../assets/images/new-logo-uz-white.svg';
import { AiFillInstagram } from 'react-icons/ai';

const FooterBeta: React.FC = () => {
	const { t } = useTranslation();
	const active_lang = localStorage.getItem('i18lang');

	return (
		<div className='w-full py-6 bg-main_color text-white'>
			<div className='container mx-auto px-5 flex max-sm:flex-wrap justify-between gap-6 '>
				<div className='sm:w-1/5 w-fit min-w-[180px]'>
					<Link
						to='/'
						className=' flex items-center self-start'>
						{active_lang == 'uz' ? (
							<img
								src={Arbitrator_new_logo_uz}
								alt='logo'
								className='w-[240px] h-[70px] object-cover'
							/>
						) : active_lang == 'ru' ? (
							<img
								src={Arbitrator_new_logo_ru}
								alt='logo'
								className='w-[280px] h-[70px] object-cover'
							/>
						) : (
							<img
								src={Arbitrator_new_logo_eng}
								alt='logo'
								className='w-[240px] h-[70px] object-cover'
							/>
						)}
					</Link>
				</div>
				<div className='sm:w-1/5 w-fit sm:hidden text-end'>
					<Link className='block xl:text-base text-base' to={'/arbitration'}>
						{t('Arbitration')}
					</Link>
					<Link className='block xl:text-base text-base' to={'/arbitration'}>
						{t('Mediation')}
					</Link>
					<Link className='block xl:text-base text-base' to={'/contact'}>
						{t('Contact us')}
					</Link>
					<Link className='block xl:text-base text-base' to={'/pravicy-policy'}>
						{t('Privacy policy')}
					</Link>
				</div>

				<div className='sm:w-3/5 w-full'>
					<h3 className='2xl:text-xl xl:text-lg text-base font-medium'>
						{t('Tashkent mediation center (UDRC)')}
					</h3>
					<p className='xl:text-base text-sm'>
						{t('The UDRC offers arbitration and mediation services to Uzbek and international parties who wish to have their disputes resolved outside of the public courtroom.')}
					</p>
					<div className='mt-4 flex items-center'>
						<a href='https://www.linkedin.com/company/tashkent-mediation-center/' target='_blank'>
							<FaLinkedin size={24} color='white' />
						</a>
						<a href='https://www.facebook.com/profile.php?id=61568589883444' target='_blank'>
							<FaFacebookSquare size={24} color='white' className='mx-5' />
						</a>
						<a href='https://t.me/mediation_centre' target='_blank'>
							<FaTelegramPlane size={24} color='white' />
						</a>
						<a href='https://www.instagram.com/tmcentre?igsh=MTRvc3NpZDM4NHFxMA==' target='_blank' className='ml-5'>
							<AiFillInstagram size={24}/>
						</a>
					</div>
				</div>

				<div className='sm:w-1/5 w-full max-sm:hidden text-end'>
					<Link className='block xl:text-base text-base' to={'/basic-information/:228'}>
						{t('Domestic arbitration court')}
					</Link>
					<Link className='block xl:text-base text-base' to={'/arbitration'}>
						{t('Mediation')}
					</Link>
					<Link className='block xl:text-base text-base' to={'/contact'}>
						{t('Contact us')}
					</Link>
					<Link className='block xl:text-base text-base' to={'/pravicy-policy'}>
						{t('Privacy policy')}
					</Link>
				</div>
			</div>

			{/* <div className='max-w-[1681px] mx-auto flex justify-between items-center gap-4  md:hidden'>
				<div className=' text-[8px] flex flex-col gap-3'>
					<h3 className='block font-bold text-sm'>{t('Arbitrators')}</h3>
					<Link to={'/about-the-center/:38'} className='block'>
						{t('About the Center')}
					</Link>
					<Link to={'/arbitrators/:45'} className='block'>
						{t('Team')}
					</Link>
					<Link
						to={'/difc-representative-office-(dubai)/:46'}
						className='block'>
						{t('Territorial Divisions')}
					</Link>
					<Link to={'/genearl-information'} className='block'>
						{t('Specialized Divisions')}
					</Link>
					<Link to={'/arbitration/:43'} className='block'>
						{t('Arbitrators')}
					</Link>
				</div>

				<Link to={'/'}>
					<img src={Logo} alt='Logo' width={160} />
				</Link>

				<div className=' text-[8px] flex flex-col gap-3 text-end'>
					<h3 className='block font-bold text-sm'>{t('Contacts')}</h3>
					<Link to={''} className='block'>
						14, bldg 3
					</Link>
					<Link to={''} className='block'>
						{t('Tashkent Uzbekistan')}
					</Link>
					<a href='mailto:Testing@gmail.com' className='block'>
						Testing@gmail.com
					</a>
					<a href='tel:+998998888888' className='block'>
						+998 99 888 88 88
					</a>
					<Link
						to={''}
						className='block border border-solid border-white py-1 px-2 max-w-[150px] w-auto mt-2 text-center'>
						{t('Feedback')}
					</Link>
				</div>
			</div> */}
			<hr className='my-6 bg-white h-[1px]' />
		</div>
	);
};

export default FooterBeta;
